 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"index": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"index": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"Activity":"Activity","ActivityManager~BasesManager~BasesManagerForm~BatchesManager~CausticityManager~ConsistensiesManager~~10dbbcf6":"ActivityManager~BasesManager~BasesManagerForm~BatchesManager~CausticityManager~ConsistensiesManager~~10dbbcf6","ActivityManager":"ActivityManager","BasesManager":"BasesManager","BasesManagerForm":"BasesManagerForm","BatchesManager~IngredientsManager~ShiftDetails~StarterTypeManager~WarehousesCarantineList~Warehouses~30351840":"BatchesManager~IngredientsManager~ShiftDetails~StarterTypeManager~WarehousesCarantineList~Warehouses~30351840","BatchesManager":"BatchesManager","ExportToCrmReport~LaboratoryReport~ResultPPReport~ShiftDetails~WarehousesInternalList~WarehousesList~9f7ba6e6":"ExportToCrmReport~LaboratoryReport~ResultPPReport~ShiftDetails~WarehousesInternalList~WarehousesList~9f7ba6e6","Calculator~DeviantReport~LossesReport~ShiftDetails~ShiftsList":"Calculator~DeviantReport~LossesReport~ShiftDetails~ShiftsList","ShiftDetails":"ShiftDetails","IngredientsManager":"IngredientsManager","StarterTypeManager":"StarterTypeManager","WarehousesCarantineList~WarehousesDoneList~WarehousesRecyclingList~WarehousesUnfinishedList~Warehous~4b5d2cb9":"WarehousesCarantineList~WarehousesDoneList~WarehousesRecyclingList~WarehousesUnfinishedList~Warehous~4b5d2cb9","WarehousesCarantineList":"WarehousesCarantineList","WarehousesDoneList":"WarehousesDoneList","WarehousesRecyclingList~WarehousesUtilizationList":"WarehousesRecyclingList~WarehousesUtilizationList","WarehousesRecyclingList":"WarehousesRecyclingList","WarehousesUtilizationList":"WarehousesUtilizationList","WarehousesUnfinishedList":"WarehousesUnfinishedList","prescriptManager":"prescriptManager","Calculator~ShiftsList":"Calculator~ShiftsList","ShiftsList":"ShiftsList","CausticityManager":"CausticityManager","ConsistensiesManager":"ConsistensiesManager","ContainersManager":"ContainersManager","CorrectorManager":"CorrectorManager","DensitiesManager":"DensitiesManager","DryCaucityManager":"DryCaucityManager","WarehousesInternalList":"WarehousesInternalList","WarehousesList":"WarehousesList","LinesDetails":"LinesDetails","LinesDetailsProxy":"LinesDetailsProxy","LinesManager":"LinesManager","LogoManager":"LogoManager","ProducedProduct":"ProducedProduct","ProvidersManager":"ProvidersManager","QualityPPsManager":"QualityPPsManager","ReasonsManager":"ReasonsManager","RegulatorManager":"RegulatorManager","ReleaseGPsManager":"ReleaseGPsManager","RolesManager":"RolesManager","RotatesManager":"RotatesManager","StoragesManager":"StoragesManager","VocabularyManager":"VocabularyManager","VolumeManager":"VolumeManager","WarehouseTransitTypes":"WarehouseTransitTypes","WashingList":"WashingList","Calculator":"Calculator","DeviantReport~LossesReport":"DeviantReport~LossesReport","DeviantReport":"DeviantReport","LossesReport":"LossesReport","ExportToCrmReport":"ExportToCrmReport","LaboratoryReport":"LaboratoryReport","ResultPPReport":"ResultPPReport","WashingsReport":"WashingsReport","Settings":"Settings"}[chunkId]||chunkId) + "." + {"Activity":"466e91ba","ActivityManager~BasesManager~BasesManagerForm~BatchesManager~CausticityManager~ConsistensiesManager~~10dbbcf6":"76fb8e90","ActivityManager":"953a4b2b","BasesManager":"0acfb788","BasesManagerForm":"2b9429f4","BatchesManager~IngredientsManager~ShiftDetails~StarterTypeManager~WarehousesCarantineList~Warehouses~30351840":"1775e8c0","BatchesManager":"ae734e8f","ExportToCrmReport~LaboratoryReport~ResultPPReport~ShiftDetails~WarehousesInternalList~WarehousesList~9f7ba6e6":"92765732","Calculator~DeviantReport~LossesReport~ShiftDetails~ShiftsList":"ef9e14da","ShiftDetails":"5e47f763","IngredientsManager":"a81116d8","StarterTypeManager":"60789b99","WarehousesCarantineList~WarehousesDoneList~WarehousesRecyclingList~WarehousesUnfinishedList~Warehous~4b5d2cb9":"b369dad8","WarehousesCarantineList":"3396ce05","WarehousesDoneList":"536163d0","WarehousesRecyclingList~WarehousesUtilizationList":"b203af97","WarehousesRecyclingList":"1e9ca074","WarehousesUtilizationList":"1bc2cf10","WarehousesUnfinishedList":"6576b7c0","prescriptManager":"2768c7ca","Calculator~ShiftsList":"146087a7","ShiftsList":"2d1dff6d","CausticityManager":"4abfb985","ConsistensiesManager":"0469e3d1","ContainersManager":"cdd93420","CorrectorManager":"adbda05f","DensitiesManager":"ccdad9c7","DryCaucityManager":"3acecf7a","WarehousesInternalList":"48e6cac1","WarehousesList":"8c51f733","LinesDetails":"75a4a313","LinesDetailsProxy":"14604dc8","LinesManager":"5403f8a6","LogoManager":"42ec6640","ProducedProduct":"10484601","ProvidersManager":"18978b54","QualityPPsManager":"02593466","ReasonsManager":"c6704dbf","RegulatorManager":"e3ae500c","ReleaseGPsManager":"f3341059","RolesManager":"4ce5e114","RotatesManager":"7c1279fb","StoragesManager":"c0b4ca6c","VocabularyManager":"8e1781a6","VolumeManager":"199185cc","WarehouseTransitTypes":"918deaae","WashingList":"4a12f2b9","Calculator":"8b2822ba","DeviantReport~LossesReport":"31a56188","DeviantReport":"0904adb9","LossesReport":"d9807219","ExportToCrmReport":"835ab4fe","LaboratoryReport":"67290d0b","ResultPPReport":"7a03a61b","WashingsReport":"c1b07fe9","Settings":"b822b428","chunk-2d216214":"873d7f60","chunk-2d216257":"34ca82f2","chunk-5d3aee18":"14a7081a"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"BasesManagerForm":1,"BatchesManager~IngredientsManager~ShiftDetails~StarterTypeManager~WarehousesCarantineList~Warehouses~30351840":1,"ShiftDetails":1,"WarehousesCarantineList~WarehousesDoneList~WarehousesRecyclingList~WarehousesUnfinishedList~Warehous~4b5d2cb9":1,"WarehousesCarantineList":1,"WarehousesDoneList":1,"WarehousesRecyclingList":1,"WarehousesUtilizationList":1,"WarehousesUnfinishedList":1,"ShiftsList":1,"WarehousesInternalList":1,"WarehousesList":1,"LinesDetails":1,"ProducedProduct":1,"VocabularyManager":1,"WashingList":1,"Calculator":1,"DeviantReport":1,"LossesReport":1,"ExportToCrmReport":1,"LaboratoryReport":1,"WashingsReport":1,"Settings":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"Activity":"Activity","ActivityManager~BasesManager~BasesManagerForm~BatchesManager~CausticityManager~ConsistensiesManager~~10dbbcf6":"ActivityManager~BasesManager~BasesManagerForm~BatchesManager~CausticityManager~ConsistensiesManager~~10dbbcf6","ActivityManager":"ActivityManager","BasesManager":"BasesManager","BasesManagerForm":"BasesManagerForm","BatchesManager~IngredientsManager~ShiftDetails~StarterTypeManager~WarehousesCarantineList~Warehouses~30351840":"BatchesManager~IngredientsManager~ShiftDetails~StarterTypeManager~WarehousesCarantineList~Warehouses~30351840","BatchesManager":"BatchesManager","ExportToCrmReport~LaboratoryReport~ResultPPReport~ShiftDetails~WarehousesInternalList~WarehousesList~9f7ba6e6":"ExportToCrmReport~LaboratoryReport~ResultPPReport~ShiftDetails~WarehousesInternalList~WarehousesList~9f7ba6e6","Calculator~DeviantReport~LossesReport~ShiftDetails~ShiftsList":"Calculator~DeviantReport~LossesReport~ShiftDetails~ShiftsList","ShiftDetails":"ShiftDetails","IngredientsManager":"IngredientsManager","StarterTypeManager":"StarterTypeManager","WarehousesCarantineList~WarehousesDoneList~WarehousesRecyclingList~WarehousesUnfinishedList~Warehous~4b5d2cb9":"WarehousesCarantineList~WarehousesDoneList~WarehousesRecyclingList~WarehousesUnfinishedList~Warehous~4b5d2cb9","WarehousesCarantineList":"WarehousesCarantineList","WarehousesDoneList":"WarehousesDoneList","WarehousesRecyclingList~WarehousesUtilizationList":"WarehousesRecyclingList~WarehousesUtilizationList","WarehousesRecyclingList":"WarehousesRecyclingList","WarehousesUtilizationList":"WarehousesUtilizationList","WarehousesUnfinishedList":"WarehousesUnfinishedList","prescriptManager":"prescriptManager","Calculator~ShiftsList":"Calculator~ShiftsList","ShiftsList":"ShiftsList","CausticityManager":"CausticityManager","ConsistensiesManager":"ConsistensiesManager","ContainersManager":"ContainersManager","CorrectorManager":"CorrectorManager","DensitiesManager":"DensitiesManager","DryCaucityManager":"DryCaucityManager","WarehousesInternalList":"WarehousesInternalList","WarehousesList":"WarehousesList","LinesDetails":"LinesDetails","LinesDetailsProxy":"LinesDetailsProxy","LinesManager":"LinesManager","LogoManager":"LogoManager","ProducedProduct":"ProducedProduct","ProvidersManager":"ProvidersManager","QualityPPsManager":"QualityPPsManager","ReasonsManager":"ReasonsManager","RegulatorManager":"RegulatorManager","ReleaseGPsManager":"ReleaseGPsManager","RolesManager":"RolesManager","RotatesManager":"RotatesManager","StoragesManager":"StoragesManager","VocabularyManager":"VocabularyManager","VolumeManager":"VolumeManager","WarehouseTransitTypes":"WarehouseTransitTypes","WashingList":"WashingList","Calculator":"Calculator","DeviantReport~LossesReport":"DeviantReport~LossesReport","DeviantReport":"DeviantReport","LossesReport":"LossesReport","ExportToCrmReport":"ExportToCrmReport","LaboratoryReport":"LaboratoryReport","ResultPPReport":"ResultPPReport","WashingsReport":"WashingsReport","Settings":"Settings"}[chunkId]||chunkId) + "." + {"Activity":"31d6cfe0","ActivityManager~BasesManager~BasesManagerForm~BatchesManager~CausticityManager~ConsistensiesManager~~10dbbcf6":"31d6cfe0","ActivityManager":"31d6cfe0","BasesManager":"31d6cfe0","BasesManagerForm":"66e72b6a","BatchesManager~IngredientsManager~ShiftDetails~StarterTypeManager~WarehousesCarantineList~Warehouses~30351840":"8accd666","BatchesManager":"31d6cfe0","ExportToCrmReport~LaboratoryReport~ResultPPReport~ShiftDetails~WarehousesInternalList~WarehousesList~9f7ba6e6":"31d6cfe0","Calculator~DeviantReport~LossesReport~ShiftDetails~ShiftsList":"31d6cfe0","ShiftDetails":"42c6bd4f","IngredientsManager":"31d6cfe0","StarterTypeManager":"31d6cfe0","WarehousesCarantineList~WarehousesDoneList~WarehousesRecyclingList~WarehousesUnfinishedList~Warehous~4b5d2cb9":"c6f010d6","WarehousesCarantineList":"a0a9f794","WarehousesDoneList":"3ea3206f","WarehousesRecyclingList~WarehousesUtilizationList":"31d6cfe0","WarehousesRecyclingList":"3ea3206f","WarehousesUtilizationList":"3ea3206f","WarehousesUnfinishedList":"3ea3206f","prescriptManager":"31d6cfe0","Calculator~ShiftsList":"31d6cfe0","ShiftsList":"1c0201b9","CausticityManager":"31d6cfe0","ConsistensiesManager":"31d6cfe0","ContainersManager":"31d6cfe0","CorrectorManager":"31d6cfe0","DensitiesManager":"31d6cfe0","DryCaucityManager":"31d6cfe0","WarehousesInternalList":"4034599d","WarehousesList":"4034599d","LinesDetails":"edaa10df","LinesDetailsProxy":"31d6cfe0","LinesManager":"31d6cfe0","LogoManager":"31d6cfe0","ProducedProduct":"9e53cf56","ProvidersManager":"31d6cfe0","QualityPPsManager":"31d6cfe0","ReasonsManager":"31d6cfe0","RegulatorManager":"31d6cfe0","ReleaseGPsManager":"31d6cfe0","RolesManager":"31d6cfe0","RotatesManager":"31d6cfe0","StoragesManager":"31d6cfe0","VocabularyManager":"c41d17c4","VolumeManager":"31d6cfe0","WarehouseTransitTypes":"31d6cfe0","WashingList":"c102c9bc","Calculator":"92a60d8c","DeviantReport~LossesReport":"31d6cfe0","DeviantReport":"1c3ae62a","LossesReport":"6d00aa44","ExportToCrmReport":"e0766a14","LaboratoryReport":"3ce6166f","ResultPPReport":"31d6cfe0","WashingsReport":"10819d59","Settings":"c41d17c4","chunk-2d216214":"31d6cfe0","chunk-2d216257":"31d6cfe0","chunk-5d3aee18":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
